export default __webpack_public_path__ + "media/images/icons/chevron-c08f21e7f07e0ab7d13ff2afb300fc0e.svg";